module.exports = __webpack_public_path__ + "media/images/countryrect/mn-2da7c0fd408a379ec91a544c37f67b7f.svg";